import { render } from "./TeamComp.vue?vue&type=template&id=d142c384"
import script from "./TeamComp.vue?vue&type=script&lang=js"
export * from "./TeamComp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__